// extracted by mini-css-extract-plugin
export var homeLegalPageContainer = "m_3";